<template>
  <div class="user-stats card-height">
    <spinner :show="isLoading" />
    <div class="card">
      <h3 class="user-stats--number mt-4">{{ value }}</h3>
      <h2 class="user-stats--header">{{ title }}</h2>
      <h3 class="user-stats--number">{{ value2 }}</h3>
      <h2 class="user-stats--header">{{ title2 }}</h2>
    </div>
  </div>
</template>

<script>
import Spinner from '../Spinner';

export default {
  name: 'Stats',
  components: { Spinner, },
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '0'
    },
    title2: {
      type: String,
      default: '',
    },
    value2: {
      type: String,
      default: '0'
    },
    isLoading: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="scss">
@import "../../styles/environment/_variables";

.user-stats {
  text-align: center;

  .loading-status {
    position: absolute;
    right: 6px;
    top: 3px;
    z-index: 10;
  }

  .card {
    padding-top: 10px;
  }

  .user-stats--header,
  .user-stats--number {
    margin: 0;
    padding: 0;
  }

  .user-stats--header {
    font-weight: $font-fancy-regular;
    font-size: 18px;
    margin-bottom: 5px;
    margin-top: -10px;
    text-align: center;
  }

  .user-stats--number {
    color: $sa-mid-gray;
    font-size: 74px;
  }
}

</style>